import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {PostComment} from '../_types/content';

@Injectable({
    providedIn: 'root'
})
export class SharedStateService {
    private stateSubjects: { [key: string]: BehaviorSubject<any> } = {};
    private dialogOpenSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private modalCommentsSubject: Subject<PostComment[] | null> = new Subject<PostComment[] | null>();

    constructor(private dialog: MatDialog) {
        this.dialog?.afterOpened?.pipe(takeUntilDestroyed()).subscribe((): void => {
            this.dialogOpenSubject.next(true);
        });

        this.dialog?.afterAllClosed?.pipe(takeUntilDestroyed()).subscribe((): void => {
            this.dialogOpenSubject.next(false);
        });
    }

    setVariable(key: string, value: any): void {
        if (!this.stateSubjects[key]) {
            this.stateSubjects[key] = new BehaviorSubject<any>(value);
        } else {
            this.stateSubjects[key].next(value);
        }
    }

    getVariable(key: string): Observable<any> {
        if (!this.stateSubjects[key]) {
            this.stateSubjects[key] = new BehaviorSubject<any>(null);
        }
        return this.stateSubjects[key].asObservable();
    }

    getCurrentValue(key: string): any {
        return this.stateSubjects[key] ? this.stateSubjects[key].getValue() : null;
    }

    removeVariable(key: string): void {
        delete this.stateSubjects[key];
    }

    isDialogOpen(): Observable<boolean> {
        return this.dialogOpenSubject.asObservable();
    }

    updateModalComments(value: PostComment[] | null): void {
        return this.modalCommentsSubject.next(value);
    }

    getNewModalComments$(): Observable<PostComment[] | null> {
        return this.modalCommentsSubject.asObservable();
    }
}
